import { type CoasterProps, Coaster as UICoaster } from "@webmotors/eleanor-ui";

export function Coaster(props: CoasterProps) {
  return <UICoaster {...props} />;
}
